import range from "lodash/range";
var bits = [1, 2, 4, 8, 16, 32, 64];
export var convertBitsToWeekdays = function (bits) {
    return range(0, 7).reduce(function (acc, i) { return (bits & (1 << i) ? acc.concat(i) : acc); }, []);
};
export var convertWeekdaysToBits = function (weekdays) {
    return weekdays.reduce(function (acc, day) { return bits[day] + acc; }, 0);
};
